module.exports = __webpack_public_path__ + "img/gbt3746_1_g25-14.prt.9d27002e.jpg";